import { HTMLAttributes, forwardRef } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
	padding?: 'none' | 'sm' | 'md' | 'lg';
	hover?: boolean;
}

const Card = forwardRef<HTMLDivElement, CardProps>(
	({ padding = 'md', hover = false, className = '', children, ...props }, ref) => {
		const paddingClasses = {
			none: '',
			sm: 'p-4',
			md: 'p-6',
			lg: 'p-8',
		};

		const baseClasses =
			'bg-white dark:bg-gray-800 rounded-xl shadow-card transition-all duration-300';
		const hoverClasses = hover
			? 'cursor-pointer hover:-translate-y-0.5 hover:shadow-[0_4px_12px_rgba(0,0,0,0.1)]'
			: '';

		return (
			<div
				ref={ref}
				className={`${baseClasses} ${hoverClasses} ${paddingClasses[padding]} ${className}`}
				{...props}
			>
				{children}
			</div>
		);
	}
);

Card.displayName = 'Card';

export default Card;
